<!--抽奖未抽中弹框-->
<template>
  <van-popup
    v-model="popupShow"
    closeable
    :close-on-click-overlay="false"
    close-icon="close"
    get-container="body"
    :class="[isPc?'popup-p-pc':'popup-p']"
  >
    <div class="draw-fail-p">
      <div
        class="draw-fail-header"
        :style="{background: 'url('+drawBgImg+') center center no-repeat', backgroundSize: isPc?'5.75rem 1.14rem':'3.75rem 1.14rem'}"
      >{{content.drawResult}}</div>
      <div class="draw-fail-body">
        <div class="real-gift-p">
          <van-image
            class="true-gift"
            :width="isPc?'1.28rem':'0.98rem'"
            :height="isPc?'1.39rem':'1.09rem'"
            :src="giftImg"
          />
          <div class="form-tip">{{content.drawFailTip}}</div>
        </div>
        <div class="form-btn">
          <van-button @click="close">{{content.sure}}</van-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      drawBgImg: require('@/assets/imgs/draw-success-header.png'),
      giftImg: require('@/assets/imgs/draw-fail.png'),
      popupShow: false,
    }
  },
  computed: {
    content() {
      return this.$store.state.content
    },
    ...mapState(['isPc'])
  },
  methods: {
    show() {
      this.popupShow = true
    },
    close() {
      this.popupShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.popup-p-pc{
  background-color: transparent;
  overflow-y: visible;
  .draw-fail-p {
    width: 5.26rem;
    height: 3rem;
    position: relative;
    padding-top: 0.5rem;
    .draw-fail-header {
      width: 5.75rem;
      height: 1.14rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -0.44rem;
      padding-top: 0.46rem;
      text-align: center;
      font-size: 0.3rem;
      color: #fff;
      box-sizing: border-box;
      z-index: -1;
    }
    .draw-fail-body {
      width: 5.26rem;
      height: 2.87rem;
      background-color: #fff;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      z-index: 2;
      .real-gift-p {
        padding-top: 0.26rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .gift-tip {
          color: #fe3f3d;
          font-size: 0.2rem;
          margin-top: 0.16rem;
        }
      }
      .perfect-p {
        margin-top: 0.22rem;
        padding: 0 0.2rem;
        .title {
          color: #000;
          font-size: 0.16rem;
        }
        /deep/.van-field {
          padding: 0.07rem 0;
          .van-field__label {
            font-size: 0.16rem;
          }
          .van-field__value {
            font-size: 0.16rem;
          }
        }
      }
      .form-tip {
        text-align: center;
        margin-top: 0.06rem;
        color: #111111;
        font-size: 0.2rem;
      }
      .form-btn {
        text-align: center;
        margin-top: 0.14rem;
        display: flex;
        justify-content: center;
        .van-button {
          background-color: #fde73a;
          box-shadow: 0rem 0.03rem 0rem 0rem rgba(255, 148, 8, 0.8);
          border-radius: 10px;
          padding: 0.03rem 0.14rem 0.02rem;
          font-size: 0.22rem;
          color: #cd410a;
          font-weight: normal;
          height: 0.42rem;
          width: 1.47rem;
        }
      }
    }
  }
  /deep/.van-popup__close-icon {
    top: -0.65rem;
    right: 0;
    color: #fff;
    font-size: 0.39333rem;
  }
}
.popup-p {
  background-color: transparent;
  overflow-y: visible;
  .draw-fail-p {
    width: 3.26rem;
    height: 3rem;
    position: relative;
    padding-top: 0.5rem;
    .draw-fail-header {
      width: 3.75rem;
      height: 1.14rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -0.44rem;
      padding-top: 0.46rem;
      text-align: center;
      font-size: 0.3rem;
      color: #fff;
      box-sizing: border-box;
      z-index: -1;
    }
    .draw-fail-body {
      width: 3.26rem;
      height: 2.27rem;
      background-color: #fff;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      z-index: 2;
      .real-gift-p {
        padding-top: 0.16rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .gift-tip {
          color: #fe3f3d;
          font-size: 0.16rem;
          margin-top: 0.16rem;
        }
      }
      .perfect-p {
        margin-top: 0.22rem;
        padding: 0 0.2rem;
        .title {
          color: #000;
          font-size: 0.16rem;
        }
        /deep/.van-field {
          padding: 0.07rem 0;
          .van-field__label {
            font-size: 0.16rem;
          }
          .van-field__value {
            font-size: 0.16rem;
          }
        }
      }
      .form-tip {
        text-align: center;
        margin-top: 0.06rem;
        color: #111111;
        font-size: 0.12rem;
      }
      .form-btn {
        text-align: center;
        margin-top: 0.14rem;
        display: flex;
        justify-content: center;
        .van-button {
          background-color: #fde73a;
          box-shadow: 0rem 0.03rem 0rem 0rem rgba(255, 148, 8, 0.8);
          border-radius: 10px;
          padding: 0.03rem 0.14rem 0.02rem;
          font-size: 0.22rem;
          color: #cd410a;
          font-weight: normal;
          height: 0.42rem;
          width: 1.47rem;
        }
      }
    }
  }
  /deep/.van-popup__close-icon {
    top: -0.65rem;
    right: 0;
    color: #fff;
  }
}
</style>